const isNumber = (candidate: unknown): candidate is Number =>
  !!candidate && !isNaN(Number(candidate));

export default isNumber;
